import React from 'react';
import GameSetupForm from './GameSetupForm';

const NewGamePage = () => {
    // This wrapper can be expanded later if needed, but for now, it just renders the form.
    return <GameSetupForm />;
};

export default NewGamePage;
